const VideoIndex = () => {
    return <div>
        <iframe src="//player.bilibili.com/player.html?aid=1203129449&bvid=BV1aF4m1N7gg&cid=1505735751&p=1"
                style={{width: '100%', height: '100vh', border: 'none'}}
                scrolling="no" border="0" frameBorder="no" framespacing="0" allowFullScreen="true"></iframe>
    </div>
}

export default VideoIndex;
